import React from 'react';
import CoachingCoordinatorAddSession from 'coaching/components/CoachingCoordinatorView/CoachingCoordinatorAddSession';
import CoachingCoordinatorPeopleListView from 'coaching/components/CoachingCoordinatorView/CoachingCoordinatorPeopleListView';
import { PeopleViewProps } from 'coaching/components/CoachingCoordinatorView/CoachingCoordinatorView';

import { ParticipantRow } from 'coaching/components/CoachingCoordinatorView/CoachingCoordinatorPeopleListView';

import '../styles/CoachingCoordinatorView.scss';

type State = {
  selectedParticipant: ParticipantRow | undefined | null;
  content: 'list' | 'addSession';
};

export default class CoachingCoordinatorView extends React.Component<PeopleViewProps, State> {
  state: State = {
    selectedParticipant: null,
    content: 'list',
  };

  render() {
    const { selectedParticipant } = this.state;

    const contentComponents = {
      list: (
        <CoachingCoordinatorPeopleListView
          onShowScheduleSessionView={() => this.setState({ content: 'addSession' })}
          onSelectParticipant={participant => this.setState({ selectedParticipant: participant })}
          selectedParticipant={selectedParticipant ?? undefined}
          {...this.props}
        />
      ),
      addSession: selectedParticipant && (
        <CoachingCoordinatorAddSession
          participant={selectedParticipant}
          onHide={() => this.setState({ content: 'list' })}
        />
      ),
    };

    return (
      <div className="CoachingCoordinatorView-content">{contentComponents[this.state.content]}</div>
    );
  }
}
